/* Drive Live — « Lire la suite » (snippets/dl-read-more.liquid) */
(() => {
  if (window.dlReadMoreReady) return;
  window.dlReadMoreReady = true;

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.dl-readmore__toggle');
    if (!toggle) return;
    const wrapper = toggle.closest('[data-dl-readmore]');
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(open));
    wrapper.classList.toggle('is-open', open);
    toggle.querySelector('.dl-readmore__label').textContent = open
      ? toggle.dataset.labelClose
      : toggle.dataset.labelOpen;
  });
})();
